import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import { useAuth } from "../contexts/AuthContext";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [error, setError] = useState("");

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/dashboard");
      return;
    }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await api.get(`/billing/checkout-status/${sessionId}`);
        if (cancelled) return;
        if (r.data.session_status === "complete" ||
            r.data.subscription_status === "trialing" ||
            r.data.subscription_status === "active") {
          await refresh();
          setStatus("success");
          setTimeout(() => nav("/dashboard"), 1800);
          return;
        }
        if (attempts < 8) setTimeout(poll, 1500);
        else { setStatus("timeout"); }
      } catch (e) {
        setError(e.response?.data?.detail || "Failed to verify");
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [params, nav, refresh]);

  return (
    <>
      <Header />
      <div className="lq-container page-enter" style={{ textAlign: "center", paddingTop: 80 }}>
        {status === "checking" && (
          <>
            <div className="eyebrow">— Confirming…</div>
            <h1 className="serif" style={{ fontSize: 48, margin: "16px 0" }}>Just a moment</h1>
            <p style={{ color: "var(--text-mute)" }}>Verifying your subscription with Stripe…</p>
          </>
        )}
        {status === "success" && (
          <>
            <div style={{
              width: 64, height: 64, borderRadius: "50%",
              background: "rgba(21, 128, 61, 0.18)", color: "var(--green-light)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              fontSize: 32, marginBottom: 18,
            }}>✓</div>
            <h1 className="serif" style={{ fontSize: 48, margin: "0 0 12px" }}>You're in</h1>
            <p style={{ color: "var(--text-mute)" }}>Pro features unlocked. Redirecting to your library…</p>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <h1 className="serif" style={{ fontSize: 48, margin: "0 0 12px" }}>Hmm…</h1>
            <p style={{ color: "var(--text-mute)" }}>{error || "Could not confirm. Please refresh in a moment."}</p>
            <button className="btn btn-primary" style={{ marginTop: 18 }} onClick={() => nav("/settings")}>
              Go to Settings →
            </button>
          </>
        )}
      </div>
    </>
  );
}
